import React from 'react';

interface ExpertFilterBarProps {
  searchQuery: string;
  onSearchChange: (val: string) => void;
  selectedPlatform: string;
  onSelectPlatform: (platform: string) => void;
}

export const ExpertFilterBar: React.FC<ExpertFilterBarProps> = ({
  searchQuery,
  onSearchChange,
  selectedPlatform,
  onSelectPlatform,
}) => {
  const platforms = [
    { id: 'all', label: 'Tất cả Nền tảng' },
    { id: 'mt4', label: 'Chỉ MT4' },
    { id: 'mt5', label: 'Chỉ MT5' },
    { id: 'ctrader', label: 'Chỉ cTrader' },
  ];

  return (
    <div className="bg-white !rounded-xl !shadow-sm border border-gray-200 p-4 mb-8 flex flex-col md:flex-row justify-between items-center gap-4">
      {/* Search Bar */}
      <div className="relative w-full md:w-96">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg
            className="h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 !rounded-lg leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm transition-colors"
          placeholder="Tìm kiếm trader, phong cách giao dịch..."
        />
      </div>

      {/* Filter Tabs */}
      <div className="flex !space-x-2 w-full md:w-auto overflow-x-auto pb-1 md:pb-0">
        {platforms.map((p) => {
          const isActive = selectedPlatform.toLowerCase() === p.id.toLowerCase();
          return (
            <button
              key={p.id}
              onClick={() => onSelectPlatform(p.id)}
              className={`px-4 py-2 text-sm font-medium !rounded-lg border whitespace-nowrap transition-colors cursor-pointer ${
                isActive
                  ? 'bg-blue-600 text-white border-blue-600'
                  : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
              }`}
            >
              {p.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
